import React, { useCallback } from 'react';
import classnames from 'classnames';

export interface IMultiSearchDropdownOption {
  label?: string;
  value: string;
  renderItem?: (className?: string) => React.ReactElement;
}

export interface IMultiSearchDropdownOptionsProps {
  text: string;
  values: string[];
  options: IMultiSearchDropdownOption[];
  maxVisibleItems?: number;
  onChoose: (value?: string) => void;
  hideSelectedFromDropdown?: boolean;
  hideEmptyDisplayOptions?: boolean;
}

export const MultiSearchDropdownOptions: React.FC<IMultiSearchDropdownOptionsProps> = React.memo(
  ({
    options,
    values,
    maxVisibleItems,
    text,
    onChoose,
    hideSelectedFromDropdown = false,
    hideEmptyDisplayOptions = false,
  }) => {
    const optionsHeight = maxVisibleItems ? { style: { maxHeight: `${maxVisibleItems * 35}px` } } : {};

    const select = useCallback(
      (optionId: string) => {
        onChoose(optionId);
      },
      [onChoose]
    );

    // Filter out selected items from dropdown if hideSelectedFromDropdown is enabled
    const displayOptions = hideSelectedFromDropdown
      ? options.filter(option => !values.includes(option.value))
      : options;

    return (
      <div className="flex flex-col overflow-y-auto select-none" {...optionsHeight}>
        {hideEmptyDisplayOptions !== false && displayOptions.length === 0 ? (
          <span className="no-results flex items-center px-10px min-h-35px">
            <span className="flex font-pt-sans py-2 text-15px leading-19px">No items</span>
          </span>
        ) : (
          displayOptions.map(option => (
            <span
              key={option.value}
              className={classnames(`value-${option.value} flex items-center hover:bg-teal-40 px-10px min-h-35px`)}
              onClick={() => select(option.value ?? '')}
            >
              {option.renderItem ? (
                option.renderItem(classnames({ 'font-bold': option.value && values.includes(option.value) }))
              ) : (
                <span
                  className={classnames('font-pt-sans py-2 text-15px leading-19px', {
                    'font-bold': option.value && values.includes(option.value),
                  })}
                >
                  {option.label}
                </span>
              )}
            </span>
          ))
        )}
      </div>
    );
  }
);
